import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const CreditCardAdd = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ size, variant, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none">
    <path
      d="M19.5 3.75C21.1569 3.75 22.5 5.09315 22.5 6.75V16.6973C22.1457 16.1089 21.6241 15.6323 21 15.3359V9.75H3V17.25C3 18.0784 3.67157 18.75 4.5 18.75H16.0107C16.0491 19.2939 16.211 19.803 16.4697 20.25H4.5C2.84315 20.25 1.5 18.9069 1.5 17.25V6.75C1.5 5.09315 2.84315 3.75 4.5 3.75H19.5ZM8.25 15.75C8.66421 15.75 9 16.0858 9 16.5C9 16.9142 8.66421 17.25 8.25 17.25H5.25C4.83579 17.25 4.5 16.9142 4.5 16.5C4.5 16.0858 4.83579 15.75 5.25 15.75H8.25ZM11.25 13.5C11.6642 13.5 12 13.8358 12 14.25C12 14.6642 11.6642 15 11.25 15H5.25C4.83579 15 4.5 14.6642 4.5 14.25C4.5 13.8358 4.83579 13.5 5.25 13.5H11.25ZM4.5 5.25C3.67157 5.25 3 5.92157 3 6.75V7.5H21V6.75C21 5.92157 20.3284 5.25 19.5 5.25H4.5Z"
      fill="currentColor"
    />
    <path
      d="M19.5 17.3333V18.5M19.5 18.5V19.6667M19.5 18.5H20.6667M19.5 18.5H18.3333M23 18.5C23 20.433 21.433 22 19.5 22C17.567 22 16 20.433 16 18.5C16 16.567 17.567 15 19.5 15C21.433 15 23 16.567 23 18.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CreditCardAdd;
